/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_No_CompanyInputs */

const cs_settings_venues_no_company = /** @type {(inputs: Settings_Venues_No_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez firmy`)
};

const en_settings_venues_no_company = /** @type {(inputs: Settings_Venues_No_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No company`)
};

/**
* | output |
* | --- |
* | "No company" |
*
* @param {Settings_Venues_No_CompanyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_no_company = /** @type {((inputs?: Settings_Venues_No_CompanyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_No_CompanyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_no_company(inputs)
	return cs_settings_venues_no_company(inputs)
});